(function (global, factory) {
    if (typeof exports === 'object') {
        module.exports = factory(require('jquery') );
    } else if ( typeof define === 'function' && define.amd ) {
        define(['jquery'], factory);
    }
}(this, function (jQuery) {
    var $ = jQuery;

    /**
     * @constructor Service
     * @param config {object}
     * @param config.name {string} name of the service, by which it will be available in API.api
     * @param config.url {string} api url for this service (resource)
     * @param config.methods {array} array of all available for this service http-methods
     * @param config.providers {object} map of function that will be called just before request. It
     * get ajaxSetting jQuery object as argument and must return it. Keys of object - http-method names
     * @param config.interfaces {array} list of methods that will be return by api.service(serviceName)
     */
    var Service = (function (){
        function Service(config){
            this.name = config.name;
            this.url = config.url;
            this.methods = this._prepareMethodList(config.allowedMethods);
            this.providers = this._prepareProviders(config.methodProviders);
            this.interfaces = config.interfaces;
            this.ajaxSettings = config.ajaxSettings || {};
        }

        var fn = Service.prototype;
        fn.constructor = Service;
        fn.METHODS = ['get','post','put','patch','delete'];
        /**
         * Mehtod checks existence of element with passed argument string
         * @function _methodIsAllowed
         * @memberof Service
         * @param methodName {String} name of http-method
         * @returns {boolean}
         */
        fn._methodIsAllowed   = function _methodIsAllowed   (methodName) {
            return $.inArray(methodName, this.methods) !== -1;
        };
        /**
         * Transform all method names in lower case, check that is http-method name
         * @function _prepareMethodList
         * @param methods {Array} list of http-method names
         * @memberof Service
         * @throws Invalid method name
         * @returns {Array}
         */
        fn._prepareMethodList = function _prepareMethodList (methods) {
            var METHODS_COUNT = methods.length - 1,
                lowerCasedMethods = [],
                methodIndex = 0,
                currentMethodName;

            for (;methodIndex <= METHODS_COUNT; methodIndex++) {
                currentMethodName = methods[methodIndex].toLowerCase();
                if ( $.inArray(currentMethodName, this.METHODS) === -1 ) {
                    throw new Error('Invalid method name: '+currentMethodName);
                }
                lowerCasedMethods.push( currentMethodName );
            }

            return lowerCasedMethods;
        };
        /**
         * Accept map of functions with http-method names as values, transform all keys to lower case
         * @function _prepareProviders
         * @memberof Service
         * @param providers
         * @throws TypeError - Provider is not a function
         * @returns {object}
         */
        fn._prepareProviders  = function _prepareProviders  (providers) {
            var lowerCasedProviderList = {},
                providerKey, providerName, provider;
            for ( providerKey in providers ) {
                providerName = providerKey.toLowerCase();
                provider = providers[providerKey];
                if ( !this._methodIsAllowed(providerName) ) { throw new Error('Method is not allowed'); }
                if ( !(provider && typeof provider === 'function')  ) {
                    throw new TypeError('Provider is not function');
                }
                lowerCasedProviderList[providerName] = providers[providerKey];
            }
            return lowerCasedProviderList;
        };
        fn._getDefaultAjaxConfig = function(methodName){
            var rslt = {
                data: null,
                type: methodName.toLowerCase()
            };
            $.extend(true, rslt, this.ajaxSettings);
            return rslt;
        };
        fn._methodFactory     = function _methodFactory     (methodName) {
            var _methodName = methodName.toLowerCase();
            return function () {
                var DEEP_COPY = true,
                    httpMethod = _methodName,
                    ajaxSettings = {},
                    defaultAjaxConfig = this._getDefaultAjaxConfig(_methodName),
                    resultSettings,
                    resultMethodName, objectKeys,
                    args, argsCount, firstArg;

                defaultAjaxConfig.url = this.url;
                args = Array.prototype.slice.call(arguments,0);
                argsCount = args.length;

                if ( argsCount === 1 ) {
                    firstArg = args[0];
                    if ( typeof firstArg === 'object' ) {
                        ajaxSettings = firstArg;
                    } else {
                        objectKeys = [encodeURIComponent(firstArg)];
                    }
                } else if (arguments.length > 1) {
                    if ( typeof args[0] === 'object' ) {
                        ajaxSettings = args.splice(0,1)[0];
                    }
                    objectKeys = args.map(function(key) { return encodeURIComponent(key); });
                }
                if ( argsCount && objectKeys ) {
                    ajaxSettings.url = (ajaxSettings.url || defaultAjaxConfig.url ) + '/' + objectKeys.join('/') + '/';
                    //Remove possible slash duplication (because of trailing slash)
                    ajaxSettings.url = ajaxSettings.url.replace(/\/\//g, '/');
                }

                resultSettings = $.extend(DEEP_COPY, defaultAjaxConfig, ajaxSettings);
                resultMethodName = resultSettings.type;

                if ( this.providers[httpMethod]         ) {
                    resultSettings = this.providers[httpMethod].call(this, resultSettings);
                }

                var TRAILING_SLASH = '/',
                    resultUrl = resultSettings.url,
                    lastChar = resultUrl[resultUrl.length-1],
                    hasTrailingSlash = TRAILING_SLASH === lastChar;

                if ( !hasTrailingSlash ) { resultSettings.url += TRAILING_SLASH; }

                if ( resultMethodName !== httpMethod    ) { throw new Error('Method function name not match '); }
                if ( !this._methodIsAllowed(httpMethod) ) { throw new Error('Method not allowed');              }
                return $.ajax(resultSettings);
            }
        };

        var methodIndex = 0,
            METHODS_COUNT = fn.METHODS.length,
            currentMethod;
        for (; methodIndex < METHODS_COUNT; methodIndex++) {
            currentMethod =  fn.METHODS[methodIndex];
            fn[currentMethod] = fn._methodFactory(currentMethod);
        }

        return Service;
    })();

    var API = (function(){
        function APIConstructor(){
            var services = {};
            this.service = function service(serviceName) {
                var METHODS = ['get','post','put','patch','delete'],
                    serviceExist = services[serviceName] !== undefined,
                    serviceInterface = {},
                    service;
                if ( !serviceExist ) { throw new Error('Service ' +serviceName+' does not exist'); }
                service = services[serviceName];
                METHODS = METHODS.concat(service.interfaces);
                var methodIndex = 0,
                    METHODS_COUNT = METHODS.length - 1,
                    currentMethod;
                for (; methodIndex <= METHODS_COUNT; methodIndex++) {
                    currentMethod =  METHODS[methodIndex];
                    if ( service[currentMethod] ) {
                        serviceInterface[currentMethod] = service[currentMethod].bind(service);
                    }
                }
                return serviceInterface;
            };
            this.registerService = function registerService(service) {
                if ( !(service instanceof Service) ) { throw new TypeError('Not instance of Service'); }
                if ( services[service.name] !== undefined ) { throw new Error('Service '+service.name+' already exist'); }
                services[service.name] = service;
            }
        }
        return new APIConstructor();
    })();

    return {
        api: API,
        Service: Service
    }

}));
